
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>
<div class="flex gap-3 p-3 border-bottom-1 border-gray-300">
  <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2" />

  <div class="flex flex-column gap-1">
    <p-skeleton width="10rem" />
    <p-skeleton width="20rem" height="1.5rem" />
  </div>
</div>

